module.exports = "//d274d294w9cx2v.cloudfront.net/0091e350552c2de74635fa48dd632c0df69bb301/images/photo-single.png";